// removed by extract-text-webpack-plugin
module.exports = {"image":"nj8Ht9_8J7UgPcB1zsu60"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/00-atoms/media/image.scss
// module id = 71
// module chunks = 0